import { useEffect, useState, useRef } from "react";

import {
    Autocomplete,
    Button,
    Grid,
    ListItemButton,
    Table,
    TableBody,
    TableCell,
    TableRow,
    TextField,
    styled,
    Accordion,
    AccordionSummary,
    AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { LOCAL_CONSTANT } from "../../../page/Const";

//スタイル
const InputFormCell = styled(TableCell)({
    padding: "4px",
    fontSize: "12px",
});
const NormalButton = styled(Button)({
    //基本ボタン
    backgroundColor: "#FFFFFF",
    color: "#0E6F55",
    border: "1px solid #00AC4C",
});
const BgColorButton = styled(Button)({
    //強調ボタン
    backgroundColor: "#00AC4C",
    color: "#FFFFFF",
    float: "right",
    "&: hover": {
        backgroundColor: "#47cd82",
    },
});



export interface accordionMenuProps {
    props: {
        handleMethod: any;
        userType: any;
        disabledSearch: boolean;
        conversionCreateDate: string | null;
        statusList: any[];
        picTypeList: any[];
        requestTaskList: any[];
        picNameList: any[];
        departmentList: any[];
        districtList: any[];
        planAreaIdList: any[];
        planAreaRfcList: any[];
        departmentName: string;
        districtName: string;
        statusValueList: any[];
        picTypeValueList: any[];
        taskValueList: any[];
        picNameValueList: any[];
        districtValueList: any[];
        departmentValueList: any[];
        rfcValueList: any[];
        planAreaId: string;
        planAreaName: string;
    };
}

export const AccordionMenu: React.FC<accordionMenuProps> = ({ props }) => {

    const [expanded, setExpanded] = useState(true);

    //検索パラメータ用(ステータス)
    const [statusId, setStatusId] = useState<string[]>([]);
    //検索パラメータ用(担当依頼)
    const [picType, setPicType] = useState<string[]>([]);
    //検索パラメータ用(依頼タスク)
    const [taskId, setTaskId] = useState<string[]>([]);
    //検索パラメータ用(依頼担当者)
    const [picStaffNumber, setPicStaffNumber] = useState<string[]>([]);
    //検索パラメータ用(地区)
    const [districtCode, setDistrictCode] = useState<string[]>([]);
    //検索パラメータ用(部)
    const [departmentCode, setDepartmentCode] = useState<string[]>([]);
    //検索パラメータ用(候補地No)
    const [planAreaId, setPlanAreaId] = useState<string>("");
    //検索パラメータ用(RFC)
    const [planAreaRfc, setPlanAreaRfc] = useState<string[]>([]);


    //プルダウンの検索値パラメータ設定
    const setSearchParams = (pullDownType: string) => {
        let statusIdValues: string[] = [];
        let picTypesValues: string[] = [];
        let taskIdValues: string[] = [];
        let picNameValues: string[] = [];
        let districtValues: string[] = [];
        let departmentValues: string[] = [];
        let planAreaRfcValues: string[] = [];
        if (pullDownType === "status") {
            props.statusValueList.map((e: any) => {
                statusIdValues.push(e.value);
            });
            setStatusId(statusIdValues);
        } else if (pullDownType === "picType") {
            props.picTypeValueList.map((e: any) => {
                picTypesValues.push(e.value);
            });
            setPicType(picTypesValues);
        } else if (pullDownType === "task") {
            props.taskValueList.map((e: any) => {
                taskIdValues.push(e.value);
            });
            setTaskId(taskIdValues);
        } else if (pullDownType === "picStaffNumber") {
            props.picNameValueList.map((e: any) => {
                picNameValues.push(e.value);
            });
            setPicStaffNumber(picNameValues);
        } else if (pullDownType === "district") {
            props.districtValueList.map((e: any) => {
                districtValues.push(e.value);
            });
            setDistrictCode(districtValues);
        } else if (pullDownType === "department") {
            props.departmentValueList.map((e: any) => {
                departmentValues.push(e.value);
            });
            setDepartmentCode(departmentValues);
        } else if (pullDownType === "planAreaRfc") {
            props.rfcValueList.map((e: any) => {
                planAreaRfcValues.push(e.value);
            });
            setPlanAreaRfc(planAreaRfcValues);
        }
    };

    const handleChangeExpanded = (event: any, newValue: any) => {
        setExpanded(newValue);
    };


    return (
        <Accordion expanded={expanded} onChange={handleChangeExpanded}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>検索条件</AccordionSummary>
            <AccordionDetails>
                <Grid container>
                    <Grid item xs={5}>
                        <Table sx={{ tableLayout: "fixed" }}>
                            <TableBody>
                                <TableRow>
                                    <InputFormCell sx={{ width: "90px" }}>依頼受付日</InputFormCell>
                                    <InputFormCell>
                                        <TextField
                                            value={props.conversionCreateDate}
                                            onChange={(e) => {
                                                props.handleMethod({
                                                    target: 'setConversionCreateDate',
                                                    value: e.target.value
                                                });
                                            }}
                                            type="date"
                                            style={{ padding: "0px 5px", }}
                                        ></TextField>
                                    </InputFormCell>
                                    <InputFormCell sx={{ width: "90px" }}>ステータス</InputFormCell>
                                    <InputFormCell>
                                        <Autocomplete
                                            multiple
                                            size="small"
                                            id="AutocompStatus"
                                            limitTags={1}
                                            options={props.statusList}
                                            value={props.statusValueList}
                                            getOptionLabel={(option) => option.label}
                                            isOptionEqualToValue={(option, v) => option.value === v.value}
                                            onChange={(e, val, sit) => {
                                                if (sit === "removeOption") {
                                                    document.getElementById("AutocompStatus")?.focus();
                                                }
                                                props.handleMethod({
                                                    target: 'setStatusValueList',
                                                    value: val
                                                });
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    // onBlur={() => { setSearchParams("status"); }}
                                                    {...params}
                                                    variant="outlined"
                                                ></TextField>
                                            )}
                                        ></Autocomplete>
                                    </InputFormCell>
                                </TableRow>
                                <TableRow>
                                    <InputFormCell>部</InputFormCell>
                                    <InputFormCell>
                                        {props.userType !== LOCAL_CONSTANT.USER_TYPE.RM &&
                                            props.userType !== LOCAL_CONSTANT.USER_TYPE.RFC &&
                                            props.userType !== LOCAL_CONSTANT.USER_TYPE.GM ? (
                                            <Autocomplete
                                                multiple
                                                size="small"
                                                id="AutocompDepartment"
                                                limitTags={1}
                                                options={props.departmentList}
                                                value={props.departmentValueList}
                                                getOptionLabel={(option) => option.label}
                                                isOptionEqualToValue={(option, v) => option.value === v.value}
                                                onChange={(e, val, sit) => {
                                                    if (sit === "removeOption") {
                                                        document.getElementById("AutocompDepartment")?.focus();
                                                    }
                                                    props.handleMethod({
                                                        target: 'setDepartmentValueList',
                                                        value: val
                                                    });
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        // onBlur={() => { setSearchParams("department"); }}
                                                        {...params}
                                                        variant="outlined"
                                                    ></TextField>
                                                )}
                                            ></Autocomplete>
                                        ) : (
                                            <TextField
                                                disabled
                                                value={props.departmentName}
                                                variant="outlined"
                                            ></TextField>
                                        )}
                                    </InputFormCell>
                                    <InputFormCell>担当依頼</InputFormCell>
                                    <InputFormCell>
                                        <Autocomplete
                                            multiple
                                            size="small"
                                            id="AutocompPicType"
                                            limitTags={1}
                                            options={props.picTypeList}
                                            value={props.picTypeValueList}
                                            getOptionLabel={(option) => option.label}
                                            isOptionEqualToValue={(option, v) => option.value === v.value}
                                            onChange={(e, val, sit) => {
                                                if (sit === "removeOption") {
                                                    document.getElementById("AutocompPicType")?.focus();
                                                }
                                                props.handleMethod({
                                                    target: 'setPicTypeValueList',
                                                    value: val
                                                });
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    // onBlur={() => { setSearchParams("picType"); }}
                                                    {...params}
                                                    variant="outlined"
                                                ></TextField>
                                            )}
                                        ></Autocomplete>
                                    </InputFormCell>
                                </TableRow>
                                <TableRow>
                                    <InputFormCell>地区</InputFormCell>
                                    <InputFormCell>
                                        {props.userType !== LOCAL_CONSTANT.USER_TYPE.RM &&
                                            props.userType !== LOCAL_CONSTANT.USER_TYPE.RFC ? (
                                            <Autocomplete
                                                multiple
                                                size="small"
                                                id="AutocompDistrict"
                                                limitTags={1}
                                                options={props.districtList}
                                                value={props.districtValueList}
                                                getOptionLabel={(option) => option.label}
                                                isOptionEqualToValue={(option, v) => option.value === v.value}
                                                onChange={(e, val, sit) => {
                                                    if (sit === "removeOption") {
                                                        document.getElementById("AutocompDistrict")?.focus();
                                                    }
                                                    props.handleMethod({
                                                        target: 'setDistrictValueList',
                                                        value: val
                                                    });
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        // onBlur={() => { setSearchParams("district"); }}
                                                        {...params}
                                                        variant="outlined"
                                                    ></TextField>
                                                )}
                                            ></Autocomplete>
                                        ) : (
                                            <TextField
                                                disabled
                                                value={props.districtName}
                                                variant="outlined"
                                            ></TextField>
                                        )}
                                    </InputFormCell>
                                    <InputFormCell>
                                        依頼担当者
                                    </InputFormCell>
                                    <InputFormCell>
                                        <Autocomplete
                                            multiple
                                            size="small"
                                            id="AutocompPicName"
                                            limitTags={1}
                                            options={props.picNameList}
                                            value={props.picNameValueList}
                                            getOptionLabel={(option) => option.label}
                                            isOptionEqualToValue={(option, v) => option.value === v.value}
                                            disabled={
                                                props.userType === LOCAL_CONSTANT.USER_TYPE.RM ||
                                                props.userType === LOCAL_CONSTANT.USER_TYPE.RFC ||
                                                props.userType === LOCAL_CONSTANT.USER_TYPE.OTHER ||
                                                props.userType === LOCAL_CONSTANT.USER_TYPE.GM
                                            }
                                            onChange={(e, val, sit) => {
                                                if (sit === "removeOption") {
                                                    document.getElementById("AutocompPicName")?.focus();
                                                }
                                                props.handleMethod({
                                                    target: 'setPicNameValueList',
                                                    value: val
                                                });
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    // onBlur={() => { setSearchParams("picStaffNumber"); }}
                                                    {...params}
                                                    variant="outlined"
                                                ></TextField>
                                            )}
                                        ></Autocomplete>
                                    </InputFormCell>
                                </TableRow>
                                <TableRow>
                                    <InputFormCell>候補地No</InputFormCell>
                                    <InputFormCell>
                                        <Autocomplete
                                            size="small"
                                            id="AutocompPlanAreaId"
                                            options={props.planAreaIdList}
                                            value={props.planAreaId}
                                            getOptionLabel={(planAreaIdList) => planAreaIdList}
                                            isOptionEqualToValue={(option, v) => option === v ? true : false}
                                            onChange={(e, val, sit) => {
                                                props.handleMethod({
                                                    target: 'setPlanAreaId',
                                                    value: val === null ? "" : val
                                                });
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                ></TextField>
                                            )}
                                        ></Autocomplete>
                                    </InputFormCell>
                                    <InputFormCell>依頼タスク</InputFormCell>
                                    <InputFormCell>
                                        <Autocomplete
                                            multiple
                                            size="small"
                                            id="AutocompTask"
                                            limitTags={1}
                                            options={props.requestTaskList}
                                            value={props.taskValueList}
                                            getOptionLabel={(option) => option.label}
                                            isOptionEqualToValue={(option, v) => option.value === v.value}
                                            onChange={(e, val, sit) => {
                                                if (sit === "removeOption") {
                                                    document.getElementById("AutocompTask")?.focus();
                                                }
                                                props.handleMethod({
                                                    target: 'setTaskValueList',
                                                    value: val
                                                });
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    // onBlur={() => { setSearchParams("task"); }}
                                                    {...params}
                                                    variant="outlined"
                                                ></TextField>
                                            )}
                                        ></Autocomplete>
                                    </InputFormCell>
                                </TableRow>
                                <TableRow>
                                    <InputFormCell>候補地名</InputFormCell>
                                    <InputFormCell>
                                        <TextField
                                            value={props.planAreaName}
                                            onChange={(e) => {
                                                props.handleMethod({
                                                    target: 'setPlanAreaName',
                                                    value: e.target.value
                                                });
                                            }}
                                        ></TextField>
                                    </InputFormCell>
                                    <InputFormCell>RFC</InputFormCell>
                                    <InputFormCell>
                                        <Autocomplete
                                            multiple
                                            size="small"
                                            id="AutocompPlanAreaRfc"
                                            limitTags={1}
                                            options={props.planAreaRfcList}
                                            value={props.rfcValueList}
                                            getOptionLabel={(option) => option.label}
                                            isOptionEqualToValue={(option, v) => option.value === v.value}
                                            onChange={(e, val, sit) => {
                                                if (sit === "removeOption") {
                                                    document.getElementById("AutocompPlanAreaRfc")?.focus();
                                                }
                                                props.handleMethod({
                                                    target: 'setRfcValueList',
                                                    value: val
                                                });
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    // onBlur={() => { setSearchParams("planAreaRfc"); }}
                                                    {...params}
                                                    variant="outlined"
                                                ></TextField>
                                            )}
                                        ></Autocomplete>
                                    </InputFormCell>
                                </TableRow>
                                <TableRow>
                                    <InputFormCell></InputFormCell>
                                    <InputFormCell></InputFormCell>
                                    <InputFormCell></InputFormCell>
                                    <InputFormCell>
                                        <BgColorButton
                                            disabled={props.disabledSearch}
                                            onClick={() => {
                                                props.handleMethod({
                                                    target: 'handleSerch'
                                                })
                                            }}
                                        >検索
                                        </BgColorButton>
                                    </InputFormCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Grid>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={6}>
                        <Grid container spacing={4}>
                            {[LOCAL_CONSTANT.USER_TYPE.RM, LOCAL_CONSTANT.USER_TYPE.RFC, LOCAL_CONSTANT.USER_TYPE.OTHER, LOCAL_CONSTANT.USER_TYPE.GM].includes(props.userType) ? (
                                <>
                                    <Grid item xs={3}></Grid>
                                    <Grid item xs={3}></Grid>
                                </>
                            ) : (
                                <>
                                    <Grid item xs={3}>
                                        <NormalButton
                                            onClick={() => {
                                                props.handleMethod({
                                                    target: 'handleGisImportModalOpen'
                                                })
                                            }}
                                        >GIS取込
                                        </NormalButton>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <NormalButton
                                            onClick={() => { window.open(`${window.location.origin}/Portal/CircularHistory`); }}
                                        >全回覧履歴
                                        </NormalButton>
                                    </Grid>
                                </>
                            )}
                            <Grid item xs={3}>
                                <NormalButton
                                    onClick={() => {
                                        window.open(
                                            `${window.location.origin}/PortalReport`
                                        );
                                    }}
                                >レポート</NormalButton>
                            </Grid>
                            <Grid item xs={3}>
                                <NormalButton
                                    onClick={() => { window.open(process.env.REACT_APP_RECRUIT_VIEW); }}
                                >リクルートビュー</NormalButton>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion >
    )
}

export default AccordionMenu